import { axiosGet } from "../../Helpers";

export const loadFAQs = async (setLoading) => {
  setLoading(true);
  const response = await axiosGet("faq/listfaq");
  setLoading(false);
  const data = response.data?.data;
  data.map((item, index) => {
    item.id = index + 1;
  });
  return data;
};
